import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
var css = {
  "nav": "rui-ofCOm",
  "pagination": "rui-j1fQU",
  "paginationItem": "rui-cToPo",
  "arrowRight": "rui-LocZv",
  "arrowLeft": "rui-iAb4Z",
  "pageText": "rui-cleA1"
};
import PageItem from './PageItem';
import PageDots from './PageDots';
import PageArrow from './PageArrow';
import { paramsToQueryString } from '../../helpers';
export var DEFAULT_PAGE_SIZE = 5;
export var MAX_ITEMS = 500;
export var MAX_BLOCK = 9;
export var NEIGHBOR = 2;
export var NOOP = function NOOP() {};
var DOTS = 'DOTS';
var range = function range(from, to) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var i = from;
  var range = [];
  while (i <= to) {
    range.push(i);
    i += step;
  }
  return range;
};
var Pagination = /*#__PURE__*/function (_Component) {
  function Pagination(props) {
    var _this;
    _classCallCheck(this, Pagination);
    _this = _callSuper(this, Pagination, [props]);
    _this.gotoPage = function (page) {
      var _this$props$onPageCha = _this.props.onPageChanged,
        onPageChanged = _this$props$onPageCha === void 0 ? function (f) {
          return f;
        } : _this$props$onPageCha;
      var currentPage = Math.max(0, Math.min(page, _this.totalPages));
      var paginationData = {
        currentPage: currentPage,
        totalPages: _this.totalPages,
        pageSize: _this.pageSize,
        totalRecords: _this.totalRecords
      };
      _this.setState({
        currentPage: currentPage
      }, function () {
        return onPageChanged(paginationData);
      });
    };
    _this.handleClick = function (page) {
      return function (evt) {
        evt.preventDefault();
        _this.gotoPage(page);
      };
    };
    _this.handleMoveLeft = function (evt) {
      evt.preventDefault();
      _this.gotoPage(_this.state.currentPage - 1);
    };
    _this.handleMoveRight = function (evt) {
      evt.preventDefault();
      _this.gotoPage(_this.state.currentPage + 1);
    };
    _this.getPages = function () {
      var _this2 = _this,
        totalPages = _this2.totalPages;
      var currentPage = _this.state.currentPage;
      var maxBlocks = _this.props.maxBlocks;
      var result = [];
      if (totalPages > maxBlocks) {
        var temp = maxBlocks - (NEIGHBOR + 1);
        if (currentPage < temp) {
          result.push.apply(result, _toConsumableArray(range(1, maxBlocks - NEIGHBOR)).concat(['DOTS', totalPages]));
        } else if (currentPage >= temp && currentPage < totalPages - NEIGHBOR * 2) {
          result.push.apply(result, [1, 'DOTS'].concat(_toConsumableArray(range(currentPage - NEIGHBOR, currentPage + NEIGHBOR)), ['DOTS', totalPages]));
        } else if (currentPage >= totalPages - NEIGHBOR * 2) {
          result.push.apply(result, [1, 'DOTS'].concat(_toConsumableArray(range(totalPages - NEIGHBOR - NEIGHBOR * 2, totalPages - 1)), [totalPages]));
        }
        return result;
      }
      return _toConsumableArray(range(1, totalPages));
    };
    var total = props.total,
      pageSize = props.pageSize,
      selectedPage = props.selectedPage,
      maxItems = props.maxItems;
    var newTotal = maxItems ? Math.min(total, maxItems) : total;
    _this.pageSize = typeof pageSize === 'number' ? pageSize : DEFAULT_PAGE_SIZE;
    _this.totalRecords = typeof total === 'number' ? newTotal : 0;
    _this.totalPages = Math.ceil(_this.totalRecords / _this.pageSize);
    _this.state = {
      currentPage: selectedPage
    };
    return _this;
  }
  _inherits(Pagination, _Component);
  return _createClass(Pagination, [{
    key: "render",
    value: function render() {
      var _this3 = this;
      if (!this.totalRecords || this.totalPages === 1) {
        return null;
      }
      var _this$props = this.props,
        dataAutId = _this$props['data-aut-id'],
        prevText = _this$props.prevText,
        nextText = _this$props.nextText,
        _this$props$isMobile = _this$props.isMobile,
        isMobile = _this$props$isMobile === void 0 ? false : _this$props$isMobile,
        maxBlocks = _this$props.maxBlocks,
        location = _this$props.location;
      var currentPage = this.state.currentPage;
      var pages = this.getPages();
      var firstPage = pages[0];
      var lastPage = pages[pages.length - 1];
      var backHref = '';
      var nextHref = '';
      var href = '';
      if (location && (location === null || location === void 0 ? void 0 : location.query) && (location === null || location === void 0 ? void 0 : location.pathname)) {
        var query = location.query,
          pathname = location.pathname;
        backHref = currentPage === firstPage ? '' : "".concat(pathname, "?").concat(paramsToQueryString(Object.assign(Object.assign({}, query), {
          page: currentPage - 1
        })));
        nextHref = currentPage === lastPage ? '' : "".concat(pathname, "?").concat(paramsToQueryString(Object.assign(Object.assign({}, query), {
          page: currentPage + 1
        })));
      }
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("nav", {
        "data-aut-id": dataAutId,
        className: css.nav
      }, /*#__PURE__*/React.createElement("ul", {
        className: css.pagination
      }, /*#__PURE__*/React.createElement("li", {
        className: css.arrowLeft,
        key: "leftArrow"
      }, /*#__PURE__*/React.createElement(PageArrow, {
        "data-aut-id": "arrowLeft",
        icon: "arrowLeft",
        onClick: this.handleMoveLeft,
        disable: currentPage === firstPage,
        href: backHref,
        title: 'Previous',
        anchorText: prevText
      })), isMobile ? (/*#__PURE__*/React.createElement("span", {
        className: css.pageText
      }, currentPage, " / ", lastPage)) : pages === null || pages === void 0 ? void 0 : pages.map(function (page, index) {
        if (page === DOTS) {
          return /*#__PURE__*/React.createElement("li", {
            className: css.paginationItem,
            key: "dots-".concat(index)
          }, /*#__PURE__*/React.createElement(PageDots, {
            "data-aut-id": "pageDots"
          }));
        }
        if (location && (location === null || location === void 0 ? void 0 : location.query) && (location === null || location === void 0 ? void 0 : location.pathname)) {
          var _query = location.query,
            _pathname = location.pathname;
          href = "".concat(_pathname, "?").concat(paramsToQueryString(Object.assign(Object.assign({}, _query), {
            page: page
          })));
        }
        return /*#__PURE__*/React.createElement("li", {
          className: css.paginationItem,
          key: index
        }, /*#__PURE__*/React.createElement(PageItem, {
          "data-aut-id": "pageItem",
          key: index,
          selected: currentPage === page,
          onClick: _this3.handleClick(page),
          href: href,
          disable: lastPage > maxBlocks && currentPage < lastPage - NEIGHBOR * 2 && page === lastPage
        }, page));
      }), /*#__PURE__*/React.createElement("li", {
        className: css.arrowRight,
        key: "rightArrow"
      }, /*#__PURE__*/React.createElement(PageArrow, {
        "data-aut-id": "arrowRight",
        icon: "arrowRight",
        disable: currentPage === lastPage,
        onClick: this.handleMoveRight,
        href: nextHref,
        title: 'Next',
        anchorText: nextText
      })))));
    }
  }]);
}(Component);
Pagination.defaultProps = {
  'data-aut-id': 'pagination',
  pageSize: DEFAULT_PAGE_SIZE,
  total: null,
  selectedPage: 1,
  maxItems: MAX_ITEMS,
  maxBlocks: MAX_BLOCK
};
export default Pagination;